import React from "react"
import classes from "./Input.module.css"

const input = props => {
    return (
        <div className={classes.Wrapper}>
            {props.labelClick ? (
                <span className={classes.Title} onClick={props.changed}>
                    {props.title}
                </span>
            ) : (
                <span className={classes.Title}>{props.title}</span>
            )}
            {props.type === undefined ? (
                <input className={classes.Input} onChange={props.changed} value={props.val} />
            ) : props.type === "checkbox" ? (
                <div className={classes.Input}>
                    <input
                        className={classes.Checkbox}
                        type={props.type}
                        onChange={props.changed}
                        checked={props.val}
                        disabled={props.disabled ?? false}
                    />
                </div>
            ) : props.type === "select" ? (
                <select onChange={props.changed} value={props.val} className={classes.Input}>
                    {props.options}
                </select>
            ) : (
                <input type={props.type} className={classes.Input} onChange={props.changed} value={props.val} />
            )}
        </div>
    )
}

export default input
